module.exports = __webpack_public_path__ + "img/ba-logo.822c4d55.svg";